export { default as UserPermissions } from './user-permissions'
export { default as TenantPermissions } from './tenant-permissions'



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/index.js